import { ComparisonEntry } from '@comparison/const';
import { Category } from '@spartacus/core';

export const COMPARISON_FEATURE = 'comparison';
export const COMPARISON_DATA = '[Comparison] Comparison Data';

export interface StateWithComparison {
  [COMPARISON_FEATURE]: ComparisonState;
}

export interface ComparisonState {
  entries: ComparisonEntry[];
  loading: { [productId: string]: boolean };
  activeCategory?: string;
  sortedCategory: Category[];
}
